/**
 * Helpers for CustomerLookup. Extracted to a separate module so
 * eslint's react-refresh rule (only-export-components) doesn't fire
 * on the dialog file. Same logic, no behavioural change.
 */

export interface CustomerLookupValue {
  readonly selectedCustomerId: string | null;
  readonly name: string;
  readonly phone: string;
  readonly email: string;
  readonly description: string;
}

export const EMPTY_CUSTOMER_LOOKUP: CustomerLookupValue = {
  selectedCustomerId: null,
  name: "",
  phone: "",
  email: "",
  description: "",
};

/** Convert a CustomerLookupValue to the order-create snapshot shape.
 *  Centralises trim + drop-empty so the conversion isn't repeated at
 *  every call site. */
export function toCustomerOrderFields(value: CustomerLookupValue): {
  customer_id?: string;
  customer_name?: string;
  customer_phone?: string;
  customer_email?: string;
  description?: string;
} {
  const fields: ReturnType<typeof toCustomerOrderFields> = {};
  if (value.selectedCustomerId) fields.customer_id = value.selectedCustomerId;
  if (value.name.trim()) fields.customer_name = value.name.trim();
  if (value.phone.trim()) fields.customer_phone = value.phone.trim();
  if (value.email.trim()) fields.customer_email = value.email.trim();
  if (value.description.trim()) fields.description = value.description.trim();
  return fields;
}
